import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function ifNotAuthenticated(to, from, next) {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

function ifAuthenticated(to, from, next) {
  if (store.getters.isAuthenticated) {
    if (store.getters['mustChangePassword']) {
      next('/reset-password')
    } else {
      next()
    }
    return
  }
  next('/login')
}

const routes = [
  {
    path: '/',
    name: 'root',
    component: () =>
      import(/* webpackChunkName: "test" */ '../views/Tests.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/tests/',
    name: 'tests',
    component: () =>
      import(/* webpackChunkName: "test" */ '../views/Tests.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/tests/:id',
    name: 'test',
    component: () => import(/* webpackChunkName: "test" */ '../views/Test.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/session/:id',
    name: 'session',
    component: () =>
      import(/* webpackChunkName: "test" */ '../views/Session.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/scores',
    name: 'scores',
    component: () =>
      import(/* webpackChunkName: "test" */ '../views/Scores.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/rating',
    name: 'rating',
    component: () =>
      import(/* webpackChunkName: "test" */ '../views/Rating.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/Login.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/register',
    name: 'register',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/Register.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/reset',
    name: 'reset',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/Reset.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        store.commit('logout')
      }
      next('/login')
    }
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "about" */ '../views/404.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
